/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($) {
	"use strict";
	/*globals Tc, doT, SCS */
	/*jshint smarttabs:true */
	/**
	 * Default module implementation.
	 *
	 * @author Igor Velickovic
	 * @namespace Tc.Module.DropDownCascadeRest
	 * @class DropDownCascadeRest
	 * @extends Tc.Module
	 */
	Tc.Module.DropDownCascadeRest = Tc.Module.extend({

		/**
		* Use dummy file
		*/
		testMode: false,
		testUrl: '/etc/designs/forms/resources/getProductList.json',

		url: null,
		json: null,

		categoryDropdown: null,
		subcategoryDropdown: null,
		productDropdown: null,

		/**
		 * Hook function to do all of your module stuff.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function(callback) {
            var mod = this;

            mod.url = mod.testMode ? mod.testUrl : mod.$ctx.data('json-url');
			debug.log('Tc.Module.DropDownCascadeRest > url', mod.url);

			var selects = mod.$ctx.find('select');
			mod.categoryDropdown = $(selects[0]);
			mod.subcategoryDropdown = $(selects[1]);
			mod.productDropdown = $(selects[2]);

			mod.subcategoryDropdown.parent().hide();
			mod.productDropdown.parent().hide();

			mod.categoryDropdown.on('change', function() {
				mod.populateSubcategory();
				mod.initBox(mod.productDropdown);
				mod.productDropdown.parent().hide();
				mod.populateFieldTranslation(mod.categoryDropdown);
				mod.populateFieldTranslation(mod.subcategoryDropdown);
                mod.populateFieldTranslation(mod.productDropdown);
			});

			mod.subcategoryDropdown.on('change', function() {
				mod.populateProduct();
				mod.populateFieldTranslation(mod.subcategoryDropdown);
				mod.populateFieldTranslation(mod.productDropdown);
			});

			mod.productDropdown.on('change', function() {
				mod.populateFieldTranslation(mod.productDropdown);
			});

			$.getJSON(mod.url, function(json) {
				debug.log('Tc.Module.DropDownCascadeRest > json', json);
				mod.json = json;
				mod.populateCategory();
			});

            //mod.changeDropDownHtml();
			callback();
		},

		initBox: function($elem) {
			var mod = this;
			$elem.empty();
			$elem.append('<option value="">'+ mod.$ctx.data('empty') +'</option>');
			$elem.resetSS();
		},

		populateCategory: function() {
			var mod = this;

			if (mod.json) {
				mod.initBox(mod.categoryDropdown);
				for (var i in mod.json) {
					var item = mod.json[i];
					debug.log('Tc.Module.DropDownCascadeRest > item', item);
					var name = mod.translationName(item.translations);
					var id = item.id;
					debug.log('Tc.Module.DropDownCascadeRest > categoryDropdown > id , name', id, name);
					var option = $('<option value="'+ id +'">'+ name +'</option>');
                    option.data('json', item.subCategoryItems);

					mod.categoryDropdown.append(option);
				}
				mod.categoryDropdown.resetSS();
			}
		},

		populateSubcategory: function() {
			var mod = this;

			var selected = mod.categoryDropdown.find("option:selected");
			debug.log('Tc.Module.DropDownCascadeRest > selected',selected.val());
			var json = selected.data('json');
			if (json){
				mod.initBox(mod.subcategoryDropdown);
				for (var j in json) {
					var item = json[j];
					var id = item.id;
					var name = mod.translationName(item.translations);
					debug.log('Tc.Module.DropDownCascadeRest > subcategoryDropdown > id , name', id, name);
					var option = $('<option value="'+ id +'">'+ name +'</option>');
					option.data('json', item.products);
					mod.subcategoryDropdown.append(option);
				}
				mod.subcategoryDropdown.resetSS();
			}

			mod.subcategoryDropdown.parent().show();
		},

		populateProduct: function() {
			var mod = this;

			var selected = mod.subcategoryDropdown.find("option:selected");
			debug.log('Tc.Module.DropDownCascadeRest > selected',selected.val());
			var json = selected.data('json');
			if (json){
				mod.initBox(mod.productDropdown);
				for (var j in json) {
					var item = json[j];
					var id = item.name;
					var name = mod.translationName(item.translations);
					debug.log('Tc.Module.DropDownCascadeRest > productDropdown > id , name', id, name);
					var option = $('<option value="'+ id +'">'+ name +'</option>');
					option.data('json', item.products);
					mod.productDropdown.append(option);
				}
				mod.productDropdown.resetSS();
			}
			mod.productDropdown.parent().show();
		},

		populateFieldTranslation: function(field) {
			var mod = this;
			var selected = field.find("option:selected");
			var hidden_name =  field.attr('name') + '_translation';
			var val = (selected.val() == '' || !field.parent().is(':visible')) ? '' : selected.text();
			mod.$ctx.find('[name='+ hidden_name +']').val(val);
		},

		translationName: function(translationArray) {
			var mod = this,
				name = '';
			for (var i in translationArray) {
				if (translationArray[i].language == mod.$ctx.data('lang')) {
					name = translationArray[i].translatedName;
				}
			}
			return name;
		}

		
	});
})(Tc.$);

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/forms/clientlibs/shared/js/modules/Tc.Module.DropDownCascadeRest.js
// module id = 274
// module chunks = 0